import { ActionReducerMap } from '@ngrx/store';
import { newsReducer } from '@features/news/state/reducers/news.reducers';

export const newsFeatureReducers: ActionReducerMap<any> = {
  userNews: newsReducer,
};
